export default "__VITE_ASSET__C$wM$V8C__"